import { createAction, createReducer, Dispatch } from '@reduxjs/toolkit';
import captureException from 'lib/captureException';
import { updateUser } from 'lib/AutolistAPI';
import { LoanDetails } from 'types/LoanDetails';

export const defaultLoanDetails: LoanDetails = {
  interestRate: 10.76, // percent
  loanDuration: 60, // months
  downPayment: 10000, // dollars
  downPaymentPercentage: 20.0,
  shouldUseDownPaymentPercentage: true,
};

export const updateUserLoanDetailsSuccess = createAction<LoanDetails>(
  'user/updateUserLoanDetails/success'
);

export function updateUserLoanDetails({
  interestRate,
  loanDuration,
  downPayment,
  downPaymentPercentage,
  shouldUseDownPaymentPercentage,
}: LoanDetails) {
  return async function userLoanDetailsUpdater(dispatch: Dispatch): Promise<void> {
    try {
      // store the authenticated user's loan details to be reused
      await updateUser({
        interest_rate: interestRate,
        loan_duration: loanDuration,
        down_payment: downPayment,
        down_payment_percentage: downPaymentPercentage,
        use_down_payment_percentage: shouldUseDownPaymentPercentage,
      });
    } catch (e) {
      captureException(e);
    }
    // update loan detail values in redux so monthly payment values
    // can change regardless of whether user is authenticated
    dispatch(
      updateUserLoanDetailsSuccess({
        interestRate,
        loanDuration,
        downPayment,
        downPaymentPercentage,
        shouldUseDownPaymentPercentage,
      })
    );
  };
}

export const loanDetailsReducer = createReducer(defaultLoanDetails, {
  [updateUserLoanDetailsSuccess.type]: (state, action) => {
    return action.payload;
  },
});
